const NETLIFY_FUNCTIONS_BASE_URL = '/.netlify/functions';

export const getFunctionUrl = (functionName: string): string => {
  return `${NETLIFY_FUNCTIONS_BASE_URL}/${functionName}`;
};

export const API_ENDPOINTS = {
  GOOD_THINGS: getFunctionUrl('goodThings'),
  GENERATE_PROMPTS: getFunctionUrl('generate-prompts'),
  IDEOGRAM_DESCRIBE: getFunctionUrl('ideogram-describe'),
  IDEOGRAM_GENERATE: getFunctionUrl('ideogram-generate'),
  SHOPIFY: getFunctionUrl('shopify'),
  STORES: getFunctionUrl('stores'),
  // Employee Directory endpoints
  EMPLOYEE_DIRECTORY: {
    GET_ALL_EMPLOYEES: getFunctionUrl('employeeDirectory-getAllEmployees'),
    GET_EMPLOYEE: getFunctionUrl('employeeDirectory-getEmployee'),
    SEARCH_EMPLOYEES: getFunctionUrl('employeeDirectory-searchEmployees'),
    GET_BY_DEPARTMENT: getFunctionUrl('employeeDirectory-getEmployeesByDepartment'),
    GET_BY_LOCATION: getFunctionUrl('employeeDirectory-getEmployeesByLocation'),
    GET_DASHBOARD_METRICS: getFunctionUrl('employeeDirectory-getDashboardMetrics'),
    GET_DEPARTMENT_STATS: getFunctionUrl('employeeDirectory-getDepartmentStats'),
    GET_LOCATION_STATS: getFunctionUrl('employeeDirectory-getLocationStats'),
    UPDATE_EMPLOYEE: getFunctionUrl('employeeDirectory-updateEmployee'),
    ADD_EMPLOYEE: getFunctionUrl('employeeDirectory-addEmployee'),
    DELETE_EMPLOYEE: getFunctionUrl('employeeDirectory-deleteEmployee'),
    UPLOAD_PHOTO: getFunctionUrl('employeeDirectory-uploadPhoto'),
    DELETE_PHOTO: getFunctionUrl('employeeDirectory-deletePhoto'),
    GET_FILTER_OPTIONS: getFunctionUrl('employeeDirectory-getFilterOptions')
  }
};
